import { gql, QueryResult, useQuery } from '@apollo/client';
import React, { createContext, useContext } from 'react';

import { prepareResponse } from '@work4all/data';

import { FspDiagnosticResult } from '@work4all/models/lib/Classes/FspDiagnosticResult.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export interface FspStatusContextValue {
  result: QueryResult<{ fspDiagnostic: FspDiagnosticResult }>;
}

const FspStatusContext = createContext<FspStatusContextValue | null>(null);

const getFspDiagnosticQuery = () => {
  const data: FspDiagnosticResult = {
    errors: null,
    warnings: null,
    fspProviderTestResults: [
      {
        errorMessage: null,
        fspId: null,
        isSuccess: null,
        testTime: null,
      },
    ],
  };

  const requestData = prepareResponse(Entities.fspDiagnosticResult, data);

  return gql`
  {
    fspDiagnostic {
      ${requestData}
    }
  }
`;
};

export const FspStatusContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const result = useQuery(getFspDiagnosticQuery());

  return (
    <FspStatusContext.Provider value={{ result }}>
      {children}
    </FspStatusContext.Provider>
  );
};

export const useFspStatusContext = (): FspStatusContextValue => {
  const context = useContext(FspStatusContext);

  if (!context) {
    throw new Error(
      'useFspStatusContext must be used within <FspStatusContextProvider>'
    );
  }

  return context;
};
